/* global Messenger */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS } from '../queryClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey as getQueryKeyCriterias } from './useCriterias';

// Config
import { crudConfig } from '../../../conf/criteria';

// Hooks
import { useCriteriaStoreInit } from '../../state/criteria/hooks/useCriteriaStoreInit';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.CRITERIA);

export const useCreateCriteria = ({ sessionToken, onSuccessCb, onErrorCb, onSettledCb }) => {
    const Client = apiClient(crudConfig);
    const reInit = useCriteriaStoreInit();

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: ({ newCriteria }) => Client.insert(sessionToken, newCriteria),
        onSuccess: (data, variables) => {
            reInit(data);
            Messenger.showMessage({
                type: `success`,
                title: `Criteria has been successfully created.`
            });
            updateCacheArray({
                queryKey: getQueryKeyCriterias(),
                action: CACHE_ACTIONS.INSERT,
                primaryKey: crudConfig.primaryKey,
                data
            });
            onSuccessCb?.({ data, context: variables?.context });
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        onSettled: () => {
            onSettledCb?.();
        },
        refetchOnWindowFocus: false
    });
};
